import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useMemo } from 'react';
import EmoteViewer from '../../extensions/extension-emote/viewer';
import DaDeviationViewer from '../../extensions/extension-deviation/Viewer/Viewer';
import DaGalleryViewer from '../../extensions/extension-gallery/Viewer/Viewer';
import MentionViewer from '../../extensions/extension-mention/Viewer/Viewer';
function cleanLinkSrc(linkOrSrc) {
    if (!/^(http|https|mailto):\/\//.test(linkOrSrc)) {
        return '';
    }
    return linkOrSrc;
}
const Heading = (props)=>{
    var _props_textAlign;
    const style = {
        textAlign: (_props_textAlign = props.textAlign) !== null && _props_textAlign !== void 0 ? _props_textAlign : undefined
    };
    switch(`${props.level}`){
        case '2':
            return /*#__PURE__*/ React.createElement("h2", {
                style: style
            }, props.children);
        case '3':
            return /*#__PURE__*/ React.createElement("h3", {
                style: style
            }, props.children);
        default:
            return /*#__PURE__*/ React.createElement("h4", {
                style: style
            }, props.children);
    }
};
function makeMark(extConfigValue, handler) {
    if (extConfigValue) {
        return handler;
    }
    return (props)=>/*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
}
function makeNode(extConfigValue, handler) {
    if (extConfigValue) {
        return handler;
    }
    return (props)=>/*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
}
export const useHandlers = (extConfig)=>{
    const handlers = useMemo(()=>{
        const markHandlers = {
            link: makeMark(extConfig.link, (props)=>{
                var _props_node_attrs, _props_node;
                return /*#__PURE__*/ React.createElement("a" // TODO allow # links and use scrollIntoViewWithHeader to scroll to anchor
                , {
                    href: cleanLinkSrc(props === null || props === void 0 ? void 0 : (_props_node = props.node) === null || _props_node === void 0 ? void 0 : (_props_node_attrs = _props_node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.href),
                    target: "_blank",
                    rel: "noopener noreferrer nofollow ugc"
                }, props.children);
            }),
            bold: makeMark(extConfig.bold, (props)=>/*#__PURE__*/ React.createElement("strong", null, props.children)),
            italic: makeMark(extConfig.italic, (props)=>/*#__PURE__*/ React.createElement("em", null, props.children)),
            underline: makeMark(extConfig.underline, (props)=>/*#__PURE__*/ React.createElement("u", null, props.children)),
            strike: makeMark(extConfig.strikethrough, (props)=>/*#__PURE__*/ React.createElement("s", null, props.children)),
            code: (props)=>/*#__PURE__*/ React.createElement(React.Fragment, null, props.children),
            textStyle: makeMark(extConfig.textColor || extConfig.textFont, (props)=>{
                var _props_node_attrs, _props_node_attrs1;
                const styles = {};
                if (((_props_node_attrs = props.node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.fontFamily) && extConfig.textFont) {
                    styles.fontFamily = props.node.attrs.fontFamily;
                }
                if (((_props_node_attrs1 = props.node.attrs) === null || _props_node_attrs1 === void 0 ? void 0 : _props_node_attrs1.color) && extConfig.textColor) {
                    styles.color = props.node.attrs.color;
                }
                return /*#__PURE__*/ React.createElement("span", {
                    style: styles
                }, props.children);
            }),
            highlight: makeMark(extConfig.textHighlight, (props)=>{
                var _props_node_attrs;
                return /*#__PURE__*/ React.createElement("mark", {
                    style: {
                        backgroundColor: (_props_node_attrs = props.node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.color
                    }
                }, props.children);
            })
        };
        const nodeHandlers = {
            'link-wrapper': (props)=>{
                return /*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
            },
            doc: (props)=>/*#__PURE__*/ React.createElement(React.Fragment, null, props.children),
            text: (props)=>/*#__PURE__*/ React.createElement(React.Fragment, null, props.node.text),
            paragraph: (props)=>{
                var _props_node_attrs, _props_node_attrs1;
                return /*#__PURE__*/ React.createElement("p", {
                    id: (_props_node_attrs = props.node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.id,
                    style: {
                        textAlign: (_props_node_attrs1 = props.node.attrs) === null || _props_node_attrs1 === void 0 ? void 0 : _props_node_attrs1.textAlign
                    }
                }, props.children);
            },
            heading: makeNode(extConfig.heading, (props)=>{
                var _props_node_attrs;
                return /*#__PURE__*/ React.createElement(Heading, {
                    level: (_props_node_attrs = props.node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.level,
                    textAlign: props.node.attrs.textAlign
                }, props.children);
            }),
            hardBreak: ()=>/*#__PURE__*/ React.createElement("br", null),
            bulletList: makeNode(extConfig.bulletList, (props)=>/*#__PURE__*/ React.createElement("ul", null, props.children)),
            orderedList: makeNode(extConfig.orderedList, (props)=>/*#__PURE__*/ React.createElement("ol", null, props.children)),
            listItem: makeNode(extConfig.bulletList || extConfig.orderedList, (props)=>/*#__PURE__*/ React.createElement("li", null, props.children)),
            codeBlock: (props)=>/*#__PURE__*/ React.createElement(React.Fragment, null, props.children),
            horizontalRule: makeNode(extConfig.horizontalRuler, ()=>/*#__PURE__*/ React.createElement("hr", null)),
            blockquote: makeNode(extConfig.blockquote, (props)=>/*#__PURE__*/ React.createElement("blockquote", null, props.children)),
            mention: makeNode(extConfig.mention, (props)=>{
                var _props_node_attrs, _props_node_attrs1, _props_node_attrs2;
                return /*#__PURE__*/ React.createElement("span", {
                    "data-type": "mention",
                    className: "mention",
                    "data-id": (_props_node_attrs = props.node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.id
                }, /*#__PURE__*/ React.createElement("a", {
                    href: `https://www.deviantart.com/${(_props_node_attrs1 = props.node.attrs) === null || _props_node_attrs1 === void 0 ? void 0 : _props_node_attrs1.id}`
                }, (_props_node_attrs2 = props.node.attrs) === null || _props_node_attrs2 === void 0 ? void 0 : _props_node_attrs2.id));
            }),
            'da-mention': makeNode(extConfig.mention, MentionViewer),
            anchor: makeNode(extConfig.anchor, (props)=>{
                var _props_node_attrs;
                return(// eslint-disable-next-line jsx-a11y/anchor-has-content
                /*#__PURE__*/ React.createElement("a", {
                    id: (_props_node_attrs = props.node.attrs) === null || _props_node_attrs === void 0 ? void 0 : _props_node_attrs.id
                }));
            }),
            'da-emote': makeNode(extConfig.emote, EmoteViewer),
            'da-deviation': makeNode(extConfig.deviation, DaDeviationViewer),
            'da-gallery': makeNode(extConfig.gallery, DaGalleryViewer)
        };
        const handlerConfig = _object_spread({}, markHandlers, nodeHandlers);
        return handlerConfig;
    }, [
        extConfig.anchor,
        extConfig.blockquote,
        extConfig.bold,
        extConfig.bulletList,
        extConfig.deviation,
        extConfig.emote,
        extConfig.gallery,
        extConfig.heading,
        extConfig.horizontalRuler,
        extConfig.italic,
        extConfig.link,
        extConfig.mention,
        extConfig.orderedList,
        extConfig.strikethrough,
        extConfig.textColor,
        extConfig.textFont,
        extConfig.textHighlight,
        extConfig.underline
    ]);
    return handlers;
};

//# sourceMappingURL=useHandlers.js.map